import { render, staticRenderFns } from "./StudioProductCard3.vue?vue&type=template&id=33402d54&scoped=true&"
import script from "./StudioProductCard3.vue?vue&type=script&lang=ts&"
export * from "./StudioProductCard3.vue?vue&type=script&lang=ts&"
import style0 from "./StudioProductCard3.vue?vue&type=style&index=0&id=33402d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33402d54",
  null
  
)

export default component.exports